import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import "./cookieBanner.css";

function CookieBanner() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const cookieAccepted = Cookies.get("cookiesAccepted");
        if (!cookieAccepted) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        Cookies.set("cookiesAccepted", "true", { expires: 365 });
        Cookies.set("theme", "light", { expires: 365 });
        Cookies.set("language", "es", { expires: 365 });
        Cookies.set("tracking", "enabled", { expires: 365 });
        // Nota: httpOnly no puede establecerse desde JS del cliente
        Cookies.set("securityToken", "randomSecureToken", { expires: 1, secure: true });
        setIsVisible(false);
    };

    const handleReject = () => {
        Cookies.set("cookiesAccepted", "false", { expires: 365 });
        Cookies.remove("theme");
        Cookies.remove("language");
        Cookies.remove("tracking");
        Cookies.remove("securityToken");
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-banner">
            <div className="cookie-content">
                <div className="cookie-text">
                    <h3 className="cookie-title">Esta página web usa cookies</h3>
                    <p className="cookie-description">
                        Te informamos que el presente sitio web utiliza cookies propias y de terceros con las siguientes finalidades:
                    </p>
                    <ul>
                        <li>Técnicas que permiten el buen funcionamiento de la web y ofrecerte una experiencia personalizada.</li>
                        <li>De personalización, que, si lo autorizas, recordarán tus preferencias en el sitio web.</li>
                        <li>Estadísticas, que, si lo autorizas, analizarán tu visita al sitio web con fines estadísticos.</li>
                    </ul>
                    <p className="cookie-description">
                        Puedes aceptar el uso de todas las cookies pulsando el botón ACEPTAR, para rechazar o configurar puede pulsar el botón CONFIGURAR y, para rechazar todas las cookies opcionales puede pulsar el botón RECHAZAR.
                    </p>
                </div>

                <div className="cookie-buttons">
                    <button onClick={handleAccept} className="cookie-button accept">Aceptar</button>
                    <button onClick={handleReject} className="cookie-button reject">Rechazar</button>
                </div>
            </div>
        </div>
    );
}

export default CookieBanner;
